/**
 * Deterministic 1:1 id — used for friendships/{id} and privateChats/{id}.
 * Must match firestore.rules `sortedPairId()`.
 */
export function sortedPairId(userId1, userId2) {
  const a = String(userId1 ?? '');
  const b = String(userId2 ?? '');
  if (!a || !b) return null;
  return a < b ? `${a}_${b}` : `${b}_${a}`;
}

/** @alias sortedPairId */
export function getConversationId(userId1, userId2) {
  return sortedPairId(userId1, userId2);
}

/** @alias sortedPairId */
export const friendshipDocumentId = sortedPairId;
